
export class PeerComparisonGroup {
	public groupName: string;
	public minRange: number;
	public maxRange: number;
}
